import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function Compagnie() {
  let navigate = useNavigate();
  const [compagnies, setCompagnies] = useState([]);
  const [selectedCompagnieId, setSelectedCompagnieId] = useState('');

  useEffect(() => {
    axios
      .get('/compagnie')
      .then((response) => {
        setCompagnies(response.data.compagnie);
        toast.warn('Chargement du liste des Compagnies');
      })
      .catch((error) => {
        toast.error(error.response.data.error);
      });
  }, []);

  const handleDelete = () => {
    if (!selectedCompagnieId) {
      toast.warn('Veuillez sélectionner une Compagnie.');
      return;
    }
    const confirmDeletion = async () => {
      await axios
        .delete(`compagnie/deleteByCompagnie/${selectedCompagnieId}`)
        .then((response) => {
          toast.success(response.data.message);
          setTimeout(() => {
            navigate('/compagnie');
          }, 2000);
        })
        .catch((error) => toast.error(error.response.data.error));
    };

    const confirmToast = toast(
      <div>
        <p>Êtes-vous sûr de vouloir supprimer cet élément ?</p>
        <button className="btn-info float-left " onClick={cancelDeletion}>
          Non
        </button>
        <button className="btn-danger float-right " onClick={confirmDeletion}>
          Oui
        </button>
      </div>,
      {
        autoClose: 3000,
        closeOnClick: false,
      }
    );
    function cancelDeletion() {
      toast.info('Suppression annulée.');
    }
  };

  return (
    <div className=" container mt-3 ">
      <div className="row">
        <div className="col">
          <h2>Suppréssion des Personnels dans une Compagnie</h2>
          <select value={selectedCompagnieId} onChange={(e) => setSelectedCompagnieId(e.target.value)} className="form-control bg-warning">
            <option value="">Selectionner votre Compagnie</option>
            {compagnies.map((compagnie) => (
              <option key={compagnie.id} value={compagnie.id}>
                {compagnie.id}: {compagnie.name} - {compagnie.bataillon.name} - {compagnie.bataillon.brigade.name}
              </option>
            ))}
          </select>          
        </div>
      </div>
      <div className="row mt-4 ">
        <div className="col d-flex justify-content-between align-items-center">
          
          <Link to="/creatcompagnie" className="btn btn-primary">
            Nouveau Compagnie
          </Link>

          <button onClick={handleDelete} className="btn btn-danger">
            Supprimer les Personnels
          </button>

        </div>
      </div>
      <h1>Compagnie</h1>
      <table className="table table-striped table-sm">
        <thead className="thead-dark">
          <tr>
            <th>Brigade</th>
            <th>Bataillon</th>
            <th>Compagnie</th>
            <th>Libelle</th>
            <th>Référence</th>
            <th>Modifier</th>
          </tr>
        </thead>
        <tbody>
          {compagnies.map((compagnie, key) => {
            return (
              <tr key={key}>
                <td>{compagnie.bataillon.brigade.name}</td>
                <td> {compagnie.bataillon.name} </td>
                <td>
                  {compagnie.name} ({compagnie.id})
                </td>
                <td> {compagnie.libelle} </td>
                <td> {compagnie.reference} </td>
                <td>
                  <a href="" onClick={() => navigate(`/compagnie/${compagnie.id}/edit`)}>
                    <i className="fa fa-edit p-2"></i>
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
     
    </div>
  );
}

export default Compagnie;
